import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createRequests from '../../common/services/create-requests';
import { wixDataReducer } from '@wix/communities-blog-client-common';
import commonReducers from '../../common/reducers';
import postCount from '../reducers/post-count';
import categories from '../../common/store/categories/categories-reducer';
import postStatsByDate from '../../common/store/post-stats-by-date/post-stats-by-date-reducer';
import { postMetadataMiddleware } from '../../common/middleware/post-metadata-middleware';

export function createReduxStore({
  appParams,
  wixCodeApi,
  compId,
  fedopsLogger,
  isSSR,
  isEditor,
  isPreview,
  language,
  bundleName,
}) {
  const p = {};
  const getStore = () => p.store;
  const staticsBaseUrl = appParams.baseUrls.staticsBaseUrl;

  const { request, platformizedRequest, aggregatorRequest } = createRequests({
    appParams,
    wixCodeApi,
    bundleName,
    getStore,
  });

  const middleware = [
    thunk.withExtraArgument({
      request,
      platformizedRequest,
      aggregatorRequest,
      wixCodeApi,
      compId,
      appParams,
      fedopsLogger,
    }),
    postMetadataMiddleware({ staticsBaseUrl, isSSR, isEditor, isPreview, language, isPostListWidget: true }),
  ];

  const reducers = combineReducers({
    ...commonReducers,
    postStatsByDate,
    wixData: wixDataReducer,
    postCount,
    categories,
  });

  p.store = createStore(reducers, undefined, applyMiddleware(...middleware));

  return p.store;
}
